import { Environment } from './models/environment.model';

export const environment: Environment = {
  production: true,
};
